<template>
  <div class="flex column">
    <div class="flex row justify_between mb1">
      <h3 class="my0 bold mya" >
        <span v-if="beacon.code">
        Beacon "<b>{{ beacon.code }}</b>"
        </span>
      </h3>
      <div class="flex">
        <icon style="display: inline; height: 18px; width: 14px;" class="mya" energy/>
        <h6 class="my0 ml1 bold mya">
          {{ beacon.batteryLevel }}%
        </h6>
      </div>
    </div>

    <input
      :name="beacon.id"
      required
      v-validate="'required'"
      v-model.trim="beacon.name"
      class="box mt0"
    />
  </div>
</template>

<script>
export default {
  name: 'beacon',

  props: { value: Object },

  data() {
    return { beacon: this.value };
  },


  watch: {
    beacon: {
      deep: true,
      handler() {
        this.updateBeacon();
      },
    },
  },

  methods: {
    async updateBeacon() {
      if (!await this.$validator.validate()) { return; }
      const beaconInput = this.beacon;
      const { errors } = await this.$mutate(this.$mutations.updateBeacon, { beaconInput });
      this.handleOptionalErrors(errors);
    },
  },
};
</script>
